/* eslint-disable react/jsx-sort-props */

/**
 * DO NOT MODIFY THIS ICON DIRECTLY.
 *
 * THIS ICON WAS AUTOMATICALLY GENERATED.
 * SVG RETRIEVED FROM SPRING FOUNDATIONS FIGMA FILE.
 * @see https://www.figma.com/design/kcg95u086DD7Sa9or8Bwpq/%F0%9F%8C%B1--Foundations---Spring-2.0?node-id=24-2&p=f&t=75lUXy0FPOr0htKP-0
 */
import React from 'react';

import {Icon as BaseIcon, type BaseIconProps} from './Icon/Icon';
import {IconComponent} from './types';

export const AddPanelRive64Icon = React.forwardRef<
  HTMLDivElement,
  BaseIconProps
>(({size = 64, ...props}, ref) => {
  return (
    <BaseIcon {...props} size={size} ref={ref}>
      <svg
        data-wf-icon="AddPanelRive64Icon"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g>
          <path
            d="M20.5 19H36.5C40.6421 19 44 22.3579 44 26.5C44 30.1831 41.3451 33.2462 37.8446 33.8798L44.9188 44.7269L44.0812 45.2731L36.7269 33.9966C36.6516 33.9989 36.5759 34 36.5 34H29.6304V33H36.5C40.0898 33 43 30.0899 43 26.5C43 22.9101 40.0898 20 36.5 20H20.5V19Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </BaseIcon>
  );
}) as IconComponent;

AddPanelRive64Icon.tags = ['add', 'plus', 'panel', 'rive', 'interface'];

AddPanelRive64Icon.category = '64x64 (Add panel)';

AddPanelRive64Icon.iconSize = 64;
